import React, { FC } from 'react'
import ProductPC from './productPc'
import ProductMobile from './productMobile'
import * as styles from './product.module.scss'

const Product: FC<any> = (props) => {
  return (
    <>
      <ProductMobile {...props} className={styles.productMobile} />
      <ProductPC {...props} className={styles.productPc} />
    </>
  );
};

export default Product;